// Anita Week 7 / Day 3 — Услуги и качество / Services and Quality
// U.S. Grade 3 upgrade for Week 7 Day 3.

const day3 = {
  id: 'day-3',
  studentId: 'anita',
  weekId: 'week-7',
  dayId: 'day-3',
  status: 'active',
  title: 'Услуги и качество / Services and Quality',
  shortTitle: 'Услуги / Services',
  theme: 'Анита учится, что такое услуга и что такое качество. / Anita learns what a service and quality are.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'business-thinking', 'services', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни показывает Аните карточки услуг. / Nimny shows Anita service cards.',
  goals: [
    'Понять слова: услуга, качество.',
    'Решить задачи Grade-3 со сравнением вариантов.',
    'Провести логику: цена или качество.',
    'Написать слова и объяснить родителю.'
  ],
  vocabulary: [
    { term: 'услуга / service', definition: 'работа, которую один делает для другого. / a work one does for another.' },
    { term: 'качество / quality', definition: 'насколько аккуратно и хорошо сделана работа. / how well the work is done.' },
    { term: 'цена / price', definition: 'сколько нимов стоит услуга (в игре). / how many nims a service costs (in the game).' },
    { term: 'выбор / choice', definition: 'решение из нескольких вариантов. / a decision between options.' },
    { term: 'скидка / discount', definition: 'уменьшение цены. / lower price.' },
    { term: 'аккуратно / neatly', definition: 'без ошибок и грязи. / without mistakes or mess.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы',
      prompt: 'Прочитай по-русски:\nуслуга\nкачество\nцена\nвыбор\nскидка\nаккуратно',
      ruPrimaryText: 'Прочитай 6 слов.', enHelpText: 'Read 6 words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение',
      prompt: 'Прочитай по-русски:\nУслуга — это работа для другого.\nКачество важнее цены.\nСкидка помогает выбрать.\nАккуратно значит без ошибок.',
      ruPrimaryText: 'Прочитай 4 фразы.', enHelpText: 'Service is a work for another. Quality matters most.', answer: 'Попытка чтения.' },
    { id: 'four-services-discount', type: 'text', title: 'Задание 3 — 4 услуги со скидкой',
      prompt: 'В карточках Нимни 4 услуги по 9 нимов каждая.\nНа все услуги действует скидка 6 нимов.\n\nОтветь:\n1. Сколько нимов всего без скидки?\n2. Сколько нимов со скидкой?',
      ruPrimaryText: 'Реши по шагам (математика Grade 3).', enHelpText: 'Math: multi-step ×, −.', answer: '4 × 9 = 36; 36 − 6 = 30 нимов.' },
    { id: 'eighty-nims-choice', type: 'text', title: 'Задание 4 — 80 нимов и выбор',
      prompt: 'У Нимни в кошельке игры 80 нимов.\nАнита выбирает две услуги: 35 нимов и 12 нимов.\n\nОтветь:\n1. Сколько нимов вместе за услуги?\n2. Сколько останется у Нимни?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Sum and subtract.', answer: '35 + 12 = 47; 80 − 47 = 33 нима.' },
    { id: 'option-a-or-b', type: 'text', title: 'Задание 5 — Вариант A или B',
      prompt: 'Вариант A: 5 услуг по 6 нимов.\nВариант B: 4 услуги по 8 нимов.\n\nОтветь:\n1. Сколько нимов в варианте A?\n2. Сколько нимов в варианте B?\n3. На сколько один вариант дороже?',
      ruPrimaryText: 'Сравни варианты.', enHelpText: 'Compare options.', answer: '5 × 6 = 30; 4 × 8 = 32; 32 − 30 = 2 нима.' },
    { id: 'eighty-four-fractions', type: 'text', title: 'Задание 6 — 84 нима: 1/3 и 1/4',
      prompt: 'У Нимни 84 нима на услуги.\n1/3 — на еду, 1/4 — на транспорт, остальное — на подарки.\n\nОтветь:\n1. Сколько на еду?\n2. Сколько на транспорт?\n3. Сколько осталось на подарки?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Fractions.', answer: '84 ÷ 3 = 28; 84 ÷ 4 = 21; 84 − 28 − 21 = 35 нимов.' },
    { id: 'logic-price-or-quality', type: 'text', title: 'Задание 7 — Логика: цена или качество',
      prompt: 'Что важнее при выборе услуги: низкая цена или хорошее качество? Почему? Ответь 1–3 предложениями.',
      ruPrimaryText: 'Логика выбора.', enHelpText: 'Logic of choice.', answer: 'Обычно качество важнее — иначе работу придётся переделать.' },
    { id: 'spelling-day3', type: 'text', title: 'Задание 8 — Правописание',
      prompt: 'Напиши:\nуслуга\nкачество\nцена\nвыбор\nскидка\n\nВставь буквы:\nусл_га\nкач_ство\nц_на\nв_бор\nск_дка',
      ruPrimaryText: 'Правописание.', enHelpText: 'Spelling.', answer: 'услуга, качество, цена, выбор, скидка.' },
    { id: 'creative-my-service-card', type: 'text', title: 'Задание 9 — Моя карточка услуги',
      prompt: 'Сделай карточку одной услуги в мире Нимни.\nУслуга: ______.\nЧто входит: ______.\nКачество: ______.\nЦена в нимах: ______.',
      ruPrimaryText: 'Творческая карточка.', enHelpText: 'Creative service card.', answer: 'Карточка с 4 полями.' },
    { id: 'speech-day3', type: 'text', title: 'Задание 10 — Объясни родителю',
      prompt: 'Скажи родителю по-русски:\nУслуга — это работа для другого.\nКачество важнее цены.\nСкидка помогает выбрать.',
      ruPrimaryText: 'Устное объяснение.', enHelpText: 'Explain to parent.', answer: 'Accept if in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова темы.',
    '2. Прочитай фразы.',
    '3. Реши все задачи.',
    '4. Сделай карточку услуги.',
    '5. Объясни родителю.'
  ],
  printWorksheet: {
    title: 'Услуги и качество / Services and Quality',
    subtitle: 'Неделя 7 · День 3 / Week 7 · Day 3',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: Анита узнаёт, что такое услуга и что такое качество.' },
        { type: 'text', text: 'Задание 1 — Слова темы:' },
        { type: 'list', items: ['услуга', 'качество', 'цена', 'выбор', 'скидка', 'аккуратно'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
        { type: 'list', items: ['□ Услуга — это работа для другого.', '□ Качество важнее цены.', '□ Скидка помогает выбрать.', '□ Аккуратно значит без ошибок.'] },
        { type: 'text', text: 'Задание 3 — 4 услуги со скидкой. Реши по шагам:' },
        { type: 'text', text: '4 услуги по 9 нимов; скидка 6 нимов.' },
        { type: 'list', items: ['4 × 9 = ______', '______ − 6 = ______'] },
        { type: 'text', text: 'Задание 4 — 80 нимов и выбор. Реши по шагам:' },
        { type: 'text', text: 'В кошельке игры 80 нимов; услуги 35 и 12 нимов.' },
        { type: 'list', items: ['35 + 12 = ______', '80 − ______ = ______'] },
        { type: 'text', text: 'Задание 5 — Вариант A или B. Реши по шагам:' },
        { type: 'text', text: 'A: 5 × 6 нимов. B: 4 × 8 нимов.' },
        { type: 'list', items: ['A: 5 × 6 = ______', 'B: 4 × 8 = ______', 'Разница: ______ − ______ = ______'] },
        { type: 'text', text: 'Задание 6 — 84 нима: 1/3 и 1/4. Реши по шагам:' },
        { type: 'text', text: '84 нима: 1/3 — еда, 1/4 — транспорт, остальное — подарки.' },
        { type: 'list', items: ['84 ÷ 3 = ______ (еда)', '84 ÷ 4 = ______ (транспорт)', '84 − ______ − ______ = ______ (подарки)'] }
      ] },
      { title: 'Русский и защита / Russian and Defense', blocks: [
        { type: 'text', text: 'Задание 7 — Логика: цена или качество. Ответь 1–3 предложениями.' },
        { type: 'text', text: 'Ответ: __________________________________________________________________' },
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['услуга   качество   цена   выбор   скидка', 'усл_га   кач_ство   ц_на   в_бор   ск_дка'] },
        { type: 'text', text: 'Задание 9 — Моя карточка услуги:' },
        { type: 'list', items: ['Услуга: ____________________', 'Что входит: ____________________', 'Качество: ____________________', 'Цена в нимах: ______'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю:' },
        { type: 'list', items: ['□ Услуга — это работа для другого.', '□ Качество важнее цены.', '□ Скидка помогает выбрать.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ math tasks  □ логика  □ правописание  □ карточка  □ объяснение.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, сделай в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    goal: 'Grade-3 математика + понимание услуги и качества.',
    mathGoal: 'Умножение, деление, сложение, вычитание, дроби 1/3 и 1/4, сравнение.',
    russianGoal: 'Прочитать 6 слов и 4 фразы, написать 5 слов.',
    readingWritingGoal: 'Карточка услуги + логика выбора.',
    practicalGoal: 'Оценить услугу по цене и качеству.',
    whatThisLessonTeaches: 'Услуга — это учебная модель работы; качество важнее скорости.',
    keyMessage: 'Хорошее качество экономит время и нимы в игре.',
    howToExplain: 'Скажите: «Сначала считаем цену, потом смотрим на качество».',
    exampleDialogue: 'Parent: Что дешевле A или B?\nChild: A — 30, B — 32.\nParent: На сколько дешевле?\nChild: 2 нима.',
    readingSupport: 'Слово «качество» читать по слогам.',
    russianSpeechGoal: 'Анита говорит одну фразу про услугу и одну про качество.',
    parentTheoryCard: {
      title: 'Как объяснить услугу и качество',
      purpose: 'Показать, что услуга — это учебное задание, а не реальная работа.',
      keyMessage: 'Качество работы — это точность и аккуратность.',
      parentScript: ['«Услуга — работа для другого.»', '«Качество важнее цены.»'],
      practiceSteps: ['Назовите услугу.', 'Спросите: «Что входит?»', 'Спросите: «Что делает её качественной?»'],
      doNotSay: ['Не обсуждайте реальные цены и услуги.', 'Не сравнивайте реальные бренды.'],
      paperOnlyNotes: ['Задания — только на бумаге и в игре нимов.']
    },
    mathAnswerKey: 'four-services-discount: 4 × 9 = 36; 36 − 6 = 30 нимов. eighty-nims-choice: 35 + 12 = 47; 80 − 47 = 33 нима. option-a-or-b: 5 × 6 = 30; 4 × 8 = 32; 32 − 30 = 2. eighty-four-fractions: 84 ÷ 3 = 28; 84 ÷ 4 = 21; 84 − 28 − 21 = 35.',
    spellingAnswerKey: 'услуга\nкачество\nцена\nвыбор\nскидка',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения фраз.' },
      { taskId: 'four-services-discount', answer: '4 × 9 = 36; 36 − 6 = 30.' },
      { taskId: 'eighty-nims-choice', answer: '35 + 12 = 47; 80 − 47 = 33.' },
      { taskId: 'option-a-or-b', answer: '5 × 6 = 30; 4 × 8 = 32; 32 − 30 = 2.' },
      { taskId: 'eighty-four-fractions', answer: '84 ÷ 3 = 28; 84 ÷ 4 = 21; 84 − 28 − 21 = 35.' },
      { taskId: 'logic-price-or-quality', answer: 'Обоснованное рассуждение.' },
      { taskId: 'spelling-day3', answer: 'услуга, качество, цена, выбор, скидка.' },
      { taskId: 'creative-my-service-card', answer: 'Карточка с услугой, содержанием, качеством и ценой.' },
      { taskId: 'speech-day3', answer: 'Объяснение по-русски.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита решила math tasks.',
      'Анита сделала карточку услуги.',
      'Анита объяснила родителю.'
    ],
    spellingCheck: 'Проверить: услуга, качество, цена, выбор, скидка.',
    readingCheck: 'Попытка русского чтения.',
    practicalCheck: 'Карточка услуги содержит 4 поля.',
    drawingCriteria: 'Карточка аккуратная и понятная.',
    commonMistakes: [
      '«Дешевле = лучше.» Правильно: «Иногда важно качество, а не цена.»',
      '«Услуга = товар.» Правильно: «Услуга — это работа для другого.»'
    ],
    discussionPrompts: [
      'Какие услуги в мире Нимни?',
      'Что делает услугу качественной?',
      'Как понять, что выбор хороший?'
    ],
    ifEasy: 'Придумай ещё одну услугу в игре с ценой и качеством.',
    ifDifficult: 'Оставить сравнение из 2 вариантов.',
    rewardGuidance: 'Базовая награда — 3 нима.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Никаких настоящих цен, магазинов и покупок; всё — на бумаге и в игре.',
    safetyNotes: 'Не обращаться к реальным магазинам, сайтам или продавцам. Ребёнок работает только с родителем.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'clear-choice', label: 'Бонус за ясный выбор', amount: 1 },
      { id: 'neat-card', label: 'Бонус за аккуратную карточку', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'four-services-discount', 'eighty-nims-choice', 'option-a-or-b', 'eighty-four-fractions', 'logic-price-or-quality', 'spelling-day3', 'creative-my-service-card', 'speech-day3'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-7-day-4'
};

export default day3;
